import { render, staticRenderFns } from "./InputPoints.vue?vue&type=template&id=2b9c6612&lang=pug"
import script from "./InputPoints.vue?vue&type=script&lang=js"
export * from "./InputPoints.vue?vue&type=script&lang=js"
import style0 from "./InputPoints.vue?vue&type=style&index=0&id=2b9c6612&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports